import React from "react";

import { InputAdornment } from "@mui/material";

import { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import TaskStatusIcon from "../../../TaskStatusIcon/TaskStatusIcon";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import { FieldEnhancer } from "./types";

import styles from "./FieldEnhancements.module.css";

export const TaskStatusEnhancer: FieldEnhancer = {
  matches: (fieldParameter: FieldParameter) => {
    return Boolean(
      fieldParameter.dataType?.type === "EnumData" &&
        fieldParameter.dataType.resourceType?.type === "StaticEnum" &&
        fieldParameter.dataType.resourceType.kinds?.includes("TaskStatus")
    );
  },

  getConfig: (currentValue: string | undefined) => ({
    renderOption: (props, option) => (
      <li
        {...props}
        className={toClassName(props.className, styles.enhancedOption)}
      >
        <TaskStatusIcon taskStatus={option.value} />
        <Text variant="body">{option.label}</Text>
      </li>
    ),

    renderStartAdornment: currentValue
      ? () => (
          <InputAdornment position="start">
            <TaskStatusIcon taskStatus={currentValue} />
          </InputAdornment>
        )
      : undefined,

    // Add grouping metadata to TaskStatus options
    enrichOptions: (options) => {
      return options.map((option) => ({
        ...option,
        meta: {
          group:
            option.value === "CANCELED" || option.value === "COMPLETED"
              ? "Closed"
              : "Active",
        },
      }));
    },

    // Enable groupBy functionality
    getGroupBy: () => (option) => option.meta.group,
  }),
};
